import React, { useState, createContext, useContext, useEffect, ReactNode } from 'react';
import { useFetchWrapper } from "../hooks/useFetchWrapper";
import { clientConfig } from '../utilities/configService';

// UserPermissionContext will keep user permissions in context and improve performance 

// Define the context type
interface UserPermissionContextType {
    userPermissions: any[];
}


const UserPermissionContext = createContext<UserPermissionContextType | undefined>(undefined);

// Custom hook to access the context
export function useUserPermissionsContext() {
    const context = useContext(UserPermissionContext);
    if (context === undefined) {
        throw new Error('useUserPermissionsContext must be used within a UserPermissionProvider');
    }
    return context;
}


// Create a UserPermissionProvider component
interface UserPermissionProviderProps {
    children: ReactNode;
}

export function UserPermissionProvider({ children }: UserPermissionProviderProps) {
    const fetchWrapper = useFetchWrapper();
    const [userPermissions, setUserPermissions] = useState<any[]>([]);
    const contextValue: UserPermissionContextType = {
        userPermissions
    };


    useEffect(() => {
        const getUserContext = async () => {
            const applicationName = clientConfig?.APPLICATION_NAME || '';
            try {
                const data = await fetchWrapper.get(`account/${applicationName}`);
                if (data?.permissions) {
                    setUserPermissions(data.permissions);
                }
            } catch {
                // User permissions are optional; the app can run anonymously,
                // so any failure to load them is intentionally ignored.
            }
        };
        getUserContext();
    }, []);



    return (
        <UserPermissionContext.Provider value={contextValue}>
            {children}
        </UserPermissionContext.Provider>
    );
}